/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Display_Grid_Settings_TitleInputs */

const en_options_display_grid_settings_title = /** @type {(inputs: Options_Display_Grid_Settings_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Display Grid Settings`)
};

const fr_options_display_grid_settings_title = /** @type {(inputs: Options_Display_Grid_Settings_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paramètres de la grille d'affichage`)
};

const de_options_display_grid_settings_title = /** @type {(inputs: Options_Display_Grid_Settings_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rastereinstellungen anzeigen`)
};

const it_options_display_grid_settings_title = /** @type {(inputs: Options_Display_Grid_Settings_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impostazioni griglia di visualizzazione`)
};

const ru_options_display_grid_settings_title = /** @type {(inputs: Options_Display_Grid_Settings_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Настройки отображения сетки`)
};

const es_options_display_grid_settings_title = /** @type {(inputs: Options_Display_Grid_Settings_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configuración de la cuadrícula de visualización`)
};

const zh_cn2_options_display_grid_settings_title = /** @type {(inputs: Options_Display_Grid_Settings_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`显示网格设置`)
};

const ja_options_display_grid_settings_title = /** @type {(inputs: Options_Display_Grid_Settings_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`グリッド設定を表示`)
};

const hi_options_display_grid_settings_title = /** @type {(inputs: Options_Display_Grid_Settings_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ग्रिड सेटिंग्स प्रदर्शित करें`)
};

const pt_pt2_options_display_grid_settings_title = /** @type {(inputs: Options_Display_Grid_Settings_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configurações da grade de exibição`)
};

/**
* | output |
* | --- |
* | "Display Grid Settings" |
*
* @param {Options_Display_Grid_Settings_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_display_grid_settings_title = /** @type {((inputs?: Options_Display_Grid_Settings_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Display_Grid_Settings_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_display_grid_settings_title(inputs)
	if (locale === "de") return de_options_display_grid_settings_title(inputs)
	if (locale === "it") return it_options_display_grid_settings_title(inputs)
	if (locale === "ru") return ru_options_display_grid_settings_title(inputs)
	if (locale === "es") return es_options_display_grid_settings_title(inputs)
	if (locale === "zh-CN") return zh_cn2_options_display_grid_settings_title(inputs)
	if (locale === "ja") return ja_options_display_grid_settings_title(inputs)
	if (locale === "hi") return hi_options_display_grid_settings_title(inputs)
	if (locale === "pt-PT") return pt_pt2_options_display_grid_settings_title(inputs)
	return en_options_display_grid_settings_title(inputs)
});